// src/App.js
import React from 'react';
import { useDarkMode } from '../../contexts/DarkModeContext';
import GameCard from '../../components/GameCard/GameCard'
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Data from '../data.json'
import PremiumGames from '../Games/PremiumGames';
import BlogCard from '../../components/BlogCard/BlogCard';

const Home = () => {
    const { gamesList } = useDarkMode();
    return (
        <div>

            <Helmet>
                <meta charset="utf-8" />
                <meta name="viewport"
                    content="width=device-width, initial-scale=1.0, minimal-ui, shrink-to-fit=no, viewport-fit=cover" />
                <meta name="apple-mobile-web-app-capable" content="yes" />
                <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
                <meta name="apple-mobile-web-app-title" content="thegameszone" />
                <meta name="HandheldFriendly" content="true" />
                <meta name="mobile-web-app-capable" content="yes" />
                <meta http-equiv="X-UA-Compatible" content="IE=edge" />
                <link rel="icon" href="/favicon.ico" />
                <link rel="apple-touch-icon" href="/logo.png" />
                <link rel="manifest" href="/manifest.json" />

                <title>Play Free Online Games | thegameszone - Best Browser Games</title>
                <meta name="title" content="Play Free Online Games | thegameszone - Best Browser Games" />
                <meta name="description"
                    content="Play the best free online games at thegameszone! Enjoy action, adventure, puzzle, and arcade games. No downloads, no sign-ups—just pure gaming fun anytime!" />
                <meta name="keywords"
                    content="free online games, play games online, thegameszone, best games, arcade games, action games, puzzle games, browser games, instant play" />

                {/* <!-- Open Graph / Facebook --> */}
                <meta property="og:title" content="Play Free Online Games | thegameszone - Best Browser Games" />
                <meta property="og:description"
                    content="Play the best free online games at thegameszone! Enjoy action, adventure, puzzle, and arcade games. No downloads, no sign-ups—just pure gaming fun anytime!" />
                <meta property="og:url" content="https://thegameszone.fun/" />
                <meta property="og:site_name" content="thegameszone" />
                <meta property="og:type" content="website" />
                <meta property="og:image" content="https://thegameszone.fun/logo.png" />
                <meta property="og:locale" content="en" />

                {/* <!-- Twitter Meta Tags --> */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Play Free Online Games | thegameszone - Best Browser Games" />
                <meta name="twitter:description"
                    content="Play the best free online games at thegameszone! Enjoy action, adventure, puzzle, and arcade games. No downloads, no sign-ups—just pure gaming fun anytime!" />
                <meta name="twitter:image" content="https://thegameszone.fun/logo.png" />

                {/* <!-- Additional SEO Meta Tags --> */}
                <meta name="robots" content="index, follow" />
                <meta name="geo.region" content="US" />
                <meta name="geo.placename" content="North America" />
                <meta name="geo.position" content="37.0902;-95.7129" />
                <meta name="ICBM" content="37.0902, -95.7129" />
                <link rel="canonical" href="https://thegameszone.fun/" />
            </Helmet>

            <div className="p-4 mt-14 sm:ml-56 ">
                <div className='flex justify-between items-center'>
                    <h1 className='text-black dark:text-white font-bold text-[24px]'>😍 You may like</h1>
                    <Link to="/category/all-games"><p className='text-black dark:text-white text-[12px]'>View All ▶</p></Link>
                </div>
                <PremiumGames flag={48} />
                {/* <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-10 gap-4 mt-2">
                    {Data.games && Data.games?.slice(0, 60)?.map((_ele, i) => {
                        const GetSlug = _ele?.name?.en?.toLowerCase().replace(/\s+/g, "-");
                        return (<>
                            <GameCard key={i} id={i} slug={GetSlug} name={_ele?.name?.en} banner={_ele?.assets?.square} link={_ele?.URL} />
                        </>
                        )
                    }

                    )}
                    {Data.games.length === 0 && <div className="col-span-12 lg:col-span-12 rounded-lg bg-white w-full h-40 flex justify-center items-center my-4">
                        <h2 className='text-[28px] font-bold'>
                            No games found.
                        </h2>
                    </div>
                    }
                </div> */}


                <div>
                    <div className='flex justify-between items-center mt-5'>
                        <h1 className='text-black dark:text-white font-bold text-[24px] mt-2'>📝 Games Blogs</h1>
                        <Link to="/blog"><p className='text-black dark:text-white text-[12px]'>View All ▶</p></Link>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-5 gap-4 mt-5">
                        {gamesList && gamesList?.slice(30, 40)?.map((_ele, i) => {
                            const GetSlug = _ele?.name?.en?.toLowerCase().replace(/\s+/g, "-");
                            return (
                                <BlogCard
                                    id={i}
                                    slug={GetSlug}
                                    name={_ele?.name?.en}
                                    banner={_ele?.assets?.cover}
                                    link={_ele?.URL}
                                    img={_ele?.assets?.square}
                                    _ele={_ele}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>

            <div>
                <div className="p-4 sm:ml-56 mt-4">
                    <div className="container mx-auto my-10">
                        <div className="rounded-lg bg-gray-50 dark:bg-black w-full flex items-center mb-7 lg:mb-12 xl:mb-16 p-6 md:p-9">
                            <div>
                                {/* Section Header */}
                                <header className="text-base lg:text-xl font-bold relative pl-4 mb-6 after:absolute after:w-[3px] md:after:w-[4px] after:h-[110%] after:top-[-5%] after:bg-[#5AC4D1] after:left-0 after:rounded-md dark:text-gray-300">
                                    <span>About thegameszone</span>
                                </header>

                                <div className="2xl:pr-36 flex flex-col gap-6 sm:gap-9 lg:gap-10">
                                    {/* Intro Section */}
                                    <section>
                                        <h1 className="text-xl lg:text-2xl font-bold capitalize mb-4 dark:text-gray-300">
                                            Discover Endless Fun with thegameszone
                                        </h1>
                                        <p className="leading-8 font-medium text-gray-700 dark:text-gray-300">
                                            Welcome to <strong>thegameszone</strong> - your ultimate hub for{" "}
                                            <strong>free online games</strong>. Enjoy a diverse collection of{" "}
                                            <strong>action, puzzle, racing, multiplayer</strong>, and{" "}
                                            <strong>strategy games</strong>. No downloads, no logins - just instant gaming
                                            across <strong>desktop, mobile, and tablets</strong>!
                                        </p>
                                    </section>

                                    {/* Why Choose Section */}
                                    <section>
                                        <h2 className="text-xl lg:text-2xl font-bold capitalize mb-4 dark:text-gray-300">
                                            Why Choose thegameszone?
                                        </h2>
                                        <p className="leading-8 font-medium text-gray-700 dark:text-gray-300">
                                            thegameszone is built for ultimate gaming convenience:
                                        </p>
                                        <ul className="list-disc pl-6 text-base font-medium text-gray-700 dark:text-gray-300 leading-8">
                                            <li>Thousands of free games updated regularly</li>
                                            <li>Instant play - no downloads, no pop-ups</li>
                                            <li>Optimized for desktop, mobile, and tablets</li>
                                            <li>Single-player and multiplayer experiences</li>
                                        </ul>
                                    </section>

                                    {/* Popular Games Section */}
                                    <section>
                                        <h2 className="text-xl lg:text-2xl font-bold capitalize mb-4 dark:text-gray-300">
                                            Our Popular Games
                                        </h2>
                                        <p className="leading-8 font-medium text-gray-700 dark:text-gray-300">
                                            Play our most popular games now:
                                        </p>
                                        <ul className="list-disc pl-6 text-base font-medium text-gray-700 dark:text-gray-300 leading-8">
                                            <li><Link to="/game/ludo-dash" className="text-blue-500 hover:underline">Ludo Dash</Link></li>
                                            <li><Link to="/game/fruit-chop" className="text-blue-500 hover:underline">Fruit Chop</Link></li>
                                            <li><Link to="/game/escape-run" className="text-blue-500 hover:underline">Escape Run</Link></li>
                                            <li><Link to="/game/save-your-pinky" className="text-blue-500 hover:underline">Save Your Pinky</Link></li>
                                            <li><Link to="/game/happy-kittens-puzzle" className="text-blue-500 hover:underline">Happy Kittens Puzzle</Link></li>
                                        </ul>
                                    </section>

                                    {/* Game Categories Section */}
                                    <section>
                                        <h2 className="text-xl lg:text-2xl font-bold capitalize mb-4 dark:text-gray-300">
                                            Explore Game Categories
                                        </h2>
                                        <p className="leading-8 font-medium text-gray-700 dark:text-gray-300">
                                            Find the perfect game in these categories:
                                        </p>
                                        <ul className="list-disc pl-6 text-base font-medium text-gray-700 dark:text-gray-300 leading-8">
                                            <li>Action & Adventure</li>
                                            <li>Puzzle & Brain Teasers</li>
                                            <li>Racing & Sports</li>
                                            <li>Classic & Retro Arcade</li>
                                            <li>Multiplayer Challenges</li>
                                        </ul>
                                    </section>

                                    {/* Community Section */}
                                    <section>
                                        <h2 className="text-xl lg:text-2xl font-bold capitalize mb-4 dark:text-gray-300">
                                            Join Our Gaming Community
                                        </h2>
                                        <p className="leading-8 font-medium text-gray-700 dark:text-gray-300">
                                            Become part of the <strong>thegameszone</strong> community! Compete, share, and
                                            explore new games daily.
                                        </p>
                                    </section>

                                    {/* Final CTA */}
                                    <section>
                                        <h2 className="text-xl lg:text-2xl font-bold capitalize mb-4 dark:text-gray-300">
                                            Play Now – 100% Free & Unlimited
                                        </h2>
                                        <p className="leading-8 font-medium text-gray-700 dark:text-gray-300">
                                            Experience endless fun with **thegameszone**-your go-to **free online gaming** platform!
                                        </p>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
